import i18n from '@/i18n'

/**
 * 取错误提示文案。
 *
 * 优先级：错误码对应的本地文案 > 服务端返回的消息 > 通用兜底。
 * 错误码文案以 `error.code.{code}` 为键存放在语言包中，新增错误码时
 * 只需在各语言包补一行，此处无需改动。
 */
export function getErrorMessage(code?: number, serverMsg?: string): string {
  if (code !== undefined) {
    const key = `error.code.${code}`
    if (i18n.exists(key)) return i18n.t(key)
  }
  return serverMsg || i18n.t('error.default')
}
